import { enqueueSnackbar } from "notistack";
import "react-toastify/dist/ReactToastify.css";

export const showNotification = (message, type = "success", onClose) => {
  enqueueSnackbar(message, {
    variant: type,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    preventDuplicate: true,
    autoHideDuration: 3000,
    onClose: () => onClose && onClose(),
  });
};
export const showError = (message, type = "error", onClose) => {
  enqueueSnackbar(message, {
    variant: type,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    preventDuplicate: true,
    autoHideDuration: 3000,
    onClose: () => onClose && onClose(),
  });
};
